/* eslint-disable @typescript-eslint/no-unused-vars */
import styles from "./DownloadOrder.module.scss";
import { useEffect, useRef, useState } from "react";
import Button from "../button/Button";
import { APIMethods, urlConstants } from "../../constants/urlConstants";
import { constants } from "../../constants/constants";
import { ToastNotification } from "../toastNotification/ToastNotification";
import errorToast from "../../../assets/images/errorToast.svg";
import successToast from "../../../assets/images/successToast.svg";
import { useDispatch, useSelector } from "react-redux";
import { updateIsLoading } from "../../../reducerSlices/loaderSlice";
import { useAxios } from "../../../services/useAxios";

const DownloadOrder = ({
  setClosedownloadOrder,
  setToastData,
  toastData,
  orderId,
}: {
  setClosedownloadOrder: React.Dispatch<React.SetStateAction<boolean>>;
  setToastData: React.Dispatch<React.SetStateAction<any>>;
  toastData: {
    message: string;
    status: string;
  };
  orderId?: string;
}) => {
  const downloadOrderRef = useRef<HTMLDivElement>(null);
  const dispatch = useDispatch();
  const { adminManageOrderDetails } = useSelector((state: any) => state);

  const downloadPDF = (data: ArrayBuffer, fileName: string) => {
    // Create a Blob from the binary data
    const blob = new Blob([data], { type: "application/pdf" });

    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileName}.pdf`;

    // Append the link to the document and trigger the download
    document.body.appendChild(a);
    a.click();

    // Clean up
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (
        downloadOrderRef &&
        downloadOrderRef.current &&
        !downloadOrderRef?.current?.contains(event.target)
      ) {
        setClosedownloadOrder(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  async function handleDownloadOrder(removeCreditTerms: boolean) {
    try {
      dispatch(updateIsLoading(true));
      const response = await fetch(
        `${urlConstants.BASE_URL}admin/master-order/download-po/${orderId}?remove_credit_terms=${removeCreditTerms}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response.ok) {
        const data = await response.arrayBuffer();
        const dynamicLabel =
          adminManageOrderDetails?.orderPO ?? "Order details";
        const fileName = removeCreditTerms
          ? `Supplier_${dynamicLabel.replace(" ", "_")}`
          : `Buyer_${dynamicLabel.replace(" ", "_")}`;
        downloadPDF(data, fileName);
        setToastData({
          message: "Order downloaded successfully",
          status: "success",
        });
      } else {
        setToastData({
          message: "Failed to download order",
          status: "fail",
        });
      }
    } catch (error) {
      console.error("Error downloading order:", error);
      setToastData({
        message: "An error occurred while downloading the order",
        status: "fail",
      });
    } finally {
      dispatch(updateIsLoading(false));
      setTimeout(() => {
        setToastData(constants.defaultToastData);
      }, 3000);
      setClosedownloadOrder(false);
    }
  }

  const handleClose = () => {
    setClosedownloadOrder(false);
  };

  return (
    <>
      <section className={styles.parentContainer} ref={downloadOrderRef}>
        <header>
          <div
            className={styles.heading}
            style={{
              textAlign: "center",
            }}
          >
            Download Order
          </div>
        </header>
        <main
          className={styles.mainContainer}
          style={{ display: "flex", flexDirection: "row", gap: "1rem" }}
        >
          <Button
            label={"Buyer"}
            secondary
            handleClick={() => handleDownloadOrder(false)}
          ></Button>
          <Button
            label={"Supplier"}
            secondary
            handleClick={() => handleDownloadOrder(true)}
          ></Button>
        </main>
      </section>
    </>
  );
};

export default DownloadOrder;
